import React from "react";
import { Container } from "./styles.js";

type BorderCardProps = {
  title: string;
  subTitle?: string;
  children?: React.ReactNode;
  headingLevel?: keyof JSX.IntrinsicElements;
  actions?: React.ReactNode;
};

const BorderCard: React.FC<BorderCardProps> = ({
  title,
  subTitle,
  children,
  headingLevel = "h2",
  actions,
}) => {
  const HeadingComponent = headingLevel as React.ElementType;

  return (
    <Container className="border-card">
      {title && (
        <div className="border-card-heading">
          <HeadingComponent>
            {title} {subTitle && <span>{subTitle}</span>}
          </HeadingComponent>
          {actions}
        </div>
      )}
      {children && <div className="border-card-content">{children}</div>}
    </Container>
  );
};

export default BorderCard;
